import React, { useCallback, useMemo, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import DefaultGrid from '../../../components/DefaultGrid';
import Loader from '../../../components/Loader';
import ModalAlert from '../../../components/ModalAlert';
import { useStateContext } from '../../../reducers';
import TooltipButton from '../../../components/TooltipButton';

function Employee(props) {
    const {accessLevel} = props;
    const [itemInEdit, setItemInEdit] = useState(null);
    const [reload, setReload] = useState(0);
    const [deleteConfirmation, setDeleteConfirmation] = useState(null);
    const [loading, setLoading] = useState(false);
    const { apiCaller } = useStateContext();

    const handleChangeStatus = useCallback((ucode, status) => {
        setLoading(true);
        apiCaller.put(`employees/status/change?id=${ucode}&status=${status}`)
            .then(() => {
                setLoading(false);
                setReload(reload === 0 ? 1 : 0);
            })
            .catch((error) => {
                console.log({error});
                setLoading(false);
            })
        ;
    }, [reload, apiCaller]);

    const handleDelete = useCallback((ucode) => {
        setLoading(true);
        apiCaller.delete(`employees/${ucode}`)
            .then(() => {
                setDeleteConfirmation(null);
                setLoading(false);
                setReload(reload === 0 ? 1 : 0);
            })
            .catch((error) => {
                console.log({error});
                setLoading(false);
            })
        ;
    }, [reload, apiCaller]);

    const columns = useMemo(() => [
        {
            Header: "NIK",
            accessor: "kode",
        },
        {
            Header: "Nama",
            accessor: "nama",
        },
        {
            Header: "Email",
            accessor: "email",
        },
        {
            Header: "Status",
            id: "sts",
            accessor: (row) => row.sts ? "Aktif" : "Tidak Aktif",
        },
        {
            Header: "Keterangan",
            accessor: "keterangan",
            disableSortBy: true,
        },
        {
            Header: "",
            id: "action",
            Cell: ({row: {original}}) => {
                return (
                    <div className="d-flex flex-wrap justify-content-center align-items-center">
                    {
                        accessLevel.can_edit > 0 &&
                        <TooltipButton
                            title="Edit"
                            size="sm"
                            variant="outline-success"
                            className="me-2"
                            onClick={() => {
                                setItemInEdit(original);
                            }}
                        >
                            <i className="fas fa-edit" />
                        </TooltipButton>
                    }
                    {
                        accessLevel.can_edit > 0 &&
                        <TooltipButton
                            title={original.sts ? "Nonaktifkan" : "Aktifkan"}
                            size="sm"
                            variant="outline-warning"
                            className="me-2"
                            onClick={() => {
                                handleChangeStatus(original.ucode, original.sts ? 0 : 1);
                            }}
                        >
                            <i className={`fas fa-${original.sts ? "times" : "check"}`} />
                        </TooltipButton>
                    }
                    {
                        accessLevel.can_delete > 0 &&
                        <TooltipButton
                            title="Hapus"
                            size="sm"
                            variant="outline-danger"
                            onClick={() => {
                                setDeleteConfirmation(original);
                            }}
                        >
                            <i className="fas fa-trash-alt" />
                        </TooltipButton>
                    }
                    </div>
                )
            },
        },
    ], [accessLevel, handleChangeStatus]);

    const grid = useMemo(() => {
        return (
            <DefaultGrid
                columns={columns}
                url="employees"
                reload={reload}
            />
        );
    }, [reload, columns]);

    return (
        <>
        {
            loading ? <Loader /> : null
        }
            <Container fluid className="m-0 p-0">
                <Row className="mb-3">
                    <Col xs={12}>
                    {
                        accessLevel.can_add > 0 &&
                        <Button size="sm" variant="light border border-dark" onClick={() => setItemInEdit({})}><i className="fas fa-plus" /></Button>
                    }
                        <Button size="sm" variant="outline-primary" className="ms-1" onClick={() => setReload(reload === 0 ? 1 : 0)}><i className="fas fa-sync-alt" /></Button>
                    </Col>
                </Row>
            {
                grid
            }
            </Container>
        {
            deleteConfirmation ?
            <ModalAlert
                onHide={() => setDeleteConfirmation(null)}
                onSave={() => handleDelete(deleteConfirmation.ucode)}
                title="Konfirmasi Penghapusan Data"
                bodyText={`Apakah anda yakin akan menghapus data role ${deleteConfirmation.nama} (${deleteConfirmation.kode})?`}
            />
            :
            null
        }
        </>
    );
}

export default Employee;
